import { MantineColor } from '@mantine/core';
import { CV_SECTION_PALETTE, CVSectionKey } from './colorPalette';

interface SectionColor {
  id: string;
  color: MantineColor;
  brandColor: string;
}

export const CV_SECTION_COLORS: Record<string, SectionColor> = {
  'personal-details': { 
    id: 'personal-details', 
    color: CV_SECTION_PALETTE['personal-details'].mantineColor,
    brandColor: CV_SECTION_PALETTE['personal-details'].color
  },
  'summary-qualifications': { 
    id: 'summary-qualifications', 
    color: CV_SECTION_PALETTE['summary-qualifications'].mantineColor,
    brandColor: CV_SECTION_PALETTE['summary-qualifications'].color
  },
  'project-experience': { 
    id: 'project-experience', 
    color: CV_SECTION_PALETTE['project-experience'].mantineColor,
    brandColor: CV_SECTION_PALETTE['project-experience'].color
  },
  'roles-overview': { 
    id: 'roles-overview', 
    color: CV_SECTION_PALETTE['roles-overview'].mantineColor,
    brandColor: CV_SECTION_PALETTE['roles-overview'].color
  },
  'skills-overview': { 
    id: 'skills-overview', 
    color: CV_SECTION_PALETTE['skills-overview'].mantineColor,
    brandColor: CV_SECTION_PALETTE['skills-overview'].color
  },
  'education': { 
    id: 'education', 
    color: CV_SECTION_PALETTE['education'].mantineColor,
    brandColor: CV_SECTION_PALETTE['education'].color
  },
  'work-experience': { 
    id: 'work-experience', 
    color: CV_SECTION_PALETTE['work-experience'].mantineColor,
    brandColor: CV_SECTION_PALETTE['work-experience'].color
  },
  'certifications': { 
    id: 'certifications', 
    color: CV_SECTION_PALETTE['certifications'].mantineColor,
    brandColor: CV_SECTION_PALETTE['certifications'].color
  },
  'languages': { 
    id: 'languages', 
    color: CV_SECTION_PALETTE['languages'].mantineColor,
    brandColor: CV_SECTION_PALETTE['languages'].color
  },
  'training-courses': { 
    id: 'training-courses', 
    color: CV_SECTION_PALETTE['training-courses'].mantineColor,
    brandColor: CV_SECTION_PALETTE['training-courses'].color
  },
} as const;

export type CVSectionColorKey = keyof typeof CV_SECTION_COLORS; 